<template>
  <button
    type="button"
    class="advanced-cookie-dialogue-action-button"
    @click.prevent="onClick"
  >
    {{ text }}
  </button>
</template>

<script>
export default {
  name: "ActionButton",
  props: {
    text: {
      type: String,
      required: true
    }
  },
  emits: ["click"],
  methods: {
    onClick() {
      this.$emit("click");
    }
  }
};
</script>

<style lang="scss">
.advanced-cookie-dialogue-action-button {
  background-color: #207970;
  padding: 1.5rem 2rem;
  border-radius: 4px;
  border: 1px solid #207970;
  font-size: 1.8rem;
  color: white;
  margin-right: 1rem;
  transition: background-color 0.2s;

  &:hover {
    background-color: #15514b;
  }

  &:focus,
  &:active {
    background-color: #2ba195;
  }

  &:focus {
    outline: 4px auto #122b40;
    outline-offset: -2px;
    border: 0;
  }
}
</style>
